import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  flex-direction: column;
  padding-top: 30px;
`;